import React from "react";

import aboutPageData from "../config/aboutPage";
import StandardSizeContainer from "../customComponent/Container/StandardSizeContainer";
import SubTitle from "../customComponent/Title/SubTitle";
import CustomParagraph from "../customComponent/Title/CustomParagraph";
import FullWidthContainer from "../customComponent/Container/FullWidthContainer";
import { MediaTextLeftImage } from "../customComponent/Media/MediaTextLeftImage";
import { MediaTextRightImage } from "../customComponent/Media/MediaTextRightImage";
import CustomContainer from "../customComponent/Container/CustomContainer";
import SectionHeadingTitle from "../customComponent/Title/SectionHeadingTitle";
import ImageList from "../customComponent/List/ImageList";
import ListWithImage from "../customComponent/List/ListWithImage";
import CardWithImageOrTitle from "../customComponent/Card/CardWithImageOrTitle";
import TwoSections from "../customComponent/TwoSections/TwoSections";
import ResultsMetrics from "../customComponent/ResultsMetrics";

const AboutPage = () => {
  const { subtitle, description } = aboutPageData.about_us_section;
  const { vision, mission } = aboutPageData.vision_mission_section;

  return (
    <StandardSizeContainer>
      <SubTitle text={subtitle} />
      <CustomParagraph text={description} />
      <FullWidthContainer className="bg-[#0C1832] md:px-24 my-8 rounded-2xl">
        <MediaTextLeftImage
          imageSrc={vision.imageSrc}
          imageAlt={vision.imageAlt}
          title={vision.title}
          text={vision.text}
        />
        <MediaTextRightImage
          imageSrc={mission.imageSrc}
          imageAlt={mission.imageAlt}
          title={mission.title}
          text={mission.text}
        />
      </FullWidthContainer>
      <CustomContainer className="max-w-4xl mx-auto text-center py-4">
        <SectionHeadingTitle text={aboutPageData.who_we_are.title} />
        <CustomParagraph text={aboutPageData.who_we_are.description} />
      </CustomContainer>
      <CustomContainer className="max-w-4xl mx-auto text-center py-4">
        <SectionHeadingTitle text={aboutPageData.what_makes_us_unique.title} />
        <ImageList items={aboutPageData.what_makes_us_unique.points} />
      </CustomContainer>
      <CustomContainer className="text-center py-4">
        <SectionHeadingTitle text={aboutPageData.core_services.title} />
        <CustomParagraph text={aboutPageData.core_services.description} />
        <ListWithImage
          data={aboutPageData.core_services.points}
          imageSrc={aboutPageData.core_services.image}
        />
      </CustomContainer>
      <CustomContainer className="text-center py-4">
        <ResultsMetrics
          title={aboutPageData.impact_section.title}
          metrics={aboutPageData.impact_section.statNumbers}
        />
      </CustomContainer>
      <CustomContainer className="text-center py-6">
        <SectionHeadingTitle text={aboutPageData.who_we_serve.title} />
        <CustomParagraph text={aboutPageData.who_we_serve.description} />
        <CardWithImageOrTitle data={aboutPageData.who_we_serve.industries} />
      </CustomContainer>
    </StandardSizeContainer>
  );
};

export default AboutPage;
